import { render, staticRenderFns } from "./Tutor.vue?vue&type=template&id=f3526038&scoped=true"
import script from "./Tutor.vue?vue&type=script&lang=js"
export * from "./Tutor.vue?vue&type=script&lang=js"
import style0 from "./Tutor.vue?vue&type=style&index=0&id=f3526038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3526038",
  null
  
)

export default component.exports